/* eslint-disable import/no-anonymous-default-export */

export default {
    ADMIN: 1,
    EDITOR: 2,
    VIEWER: 3,
    USER: 4,
    API: 5,
};
